import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { BILLING, GLOBAL_ADMIN } from 'garaje/utils/roles';
import { Permission } from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

const CAN_UPDATE_ROLES = [BILLING, GLOBAL_ADMIN];

export default class BillingAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  get canUpdate(): boolean {
    const { roleNames } = this.currentAdmin;
    return isPresent(_intersection(CAN_UPDATE_ROLES, roleNames));
  }

  get canVisit(): boolean {
    return this.authz.hasPermissionAtCurrentCompany(Permission.ACCOUNT_MANAGEMENT_BILLING_SETTINGS_MANAGE);
  }

  get canStartWorkplaceTrial(): boolean {
    return this.authz.hasPermissionAtCurrentCompany(Permission.ACCOUNT_MANAGEMENT_BILLING_WORKPLACE_TRIAL_CREATE);
  }

  get canSelfServe(): boolean {
    return !(this.state.billingCompany.isAchTransfer || this.state.billingCompany.resellerPartner);
  }
}
